
export default function PageNotFound(){
  return(
    <>
      <main className="w-full flex justify-center items-center min-h-[100vh]">
          <div>
              <img fetchPriority="high" src="./404.png" width={340} alt="not-found" />
              <div className="w-full flex justify-center mt-5">
                <span className="flex gap-x-8 text-[18px]">
                  <a href="/" className="px-8 py-1 bg-pink-200 hover:bg-pink-300 hover:text-white rounded-md border border-gray-300">Back</a>
                  <a href="https://53cloud.net" className="px-6 py-1 bg-pink-200 hover:bg-pink-300 hover:text-white rounded-md border border-gray-300">Contact</a>
                </span>
              </div>
          </div>
      </main>
    </>
  )
}